
<!-- Navbar Container -->
<!-- <header class="navbar"> -->
  <!-- Logo Left -->
  <!-- <div style="display: flex; align-items: center;">
    <img src="assets/logo.svg" alt="Logo" class="logo-pic" (click)="navigationToHome()" />
  </div> -->

  <!-- Tennis Motion Filler -->
<!-- <div class="nav-tennis-motion">
  <span class="tennis-ball"></span>
</div> -->
  <!-- Center Tagline -->
<!-- <div class="navbar-center">
  <span class="tagline">Play • Compete • Connect</span>
</div> -->


  <!-- Nav Links Center -->
  <!-- <nav style="flex: 1; display: flex; justify-content: end; align-items: center; margin-right: 50px;">
    <a [class.active]="window.location.pathname.includes('home')" [routerLink]="['/home']">Home</a>
    
    <a [class.active]="window.location.pathname.includes('help-page')" [routerLink]="['/help-page']">About</a>
 
    <a [class.active]="window.location.pathname.includes('contact-us')" [routerLink]="['/contact-us']">Contact Us</a>
  </nav> -->

  <!-- Profile Right -->
  <!-- <div style="display: flex; align-items: center; gap: 16px;">
    <i class="icon bell"></i>
    <div class="profile navright" style="display: flex; align-items: center; cursor: pointer; position: relative;" (click)="$event.stopPropagation(); isShowUser = !isShowUser">
      <span style="width: 36px; height: 36px; border-radius: 50%; background: #2A3B58; display: flex; align-items: center; justify-content: center; margin-right: 8px; color: #fff; font-size: 18px; font-weight: 600; text-transform: uppercase;">
        {{ (userDetails.firstName ? userDetails.firstName[0] : '') + (userDetails.lastName ? userDetails.lastName[0] : '') }}
      </span> -->
      <!-- <span style="color: #111827; font-weight: 500;">{{ userDetails.userName || 'Profile' }}</span> -->
      <!-- <mat-icon style="margin-left: 4px; color: #111827;">arrow_drop_down</mat-icon> -->
      <!-- Stylish Dropdown -->
      <!-- <div class="userdetails glass-dropdown" *ngIf="isShowUser">
        <div class="dropdown-header">
          <span class="avatar-large" style="width: 56px; height: 56px; border-radius: 50%; background: #2A3B58; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 28px; font-weight: 600; text-transform: uppercase;">
            {{ (userDetails.firstName ? userDetails.firstName[0] : '') + (userDetails.lastName ? userDetails.lastName[0] : '') }}
          </span>
          <div class="user-info">
            <div class="username">{{ userDetails.userName }}</div>
            <div class="useremail">{{ userDetails.email }}</div>
          </div>
        </div>
        <div class="dropdown-actions">
          <a class="link update-link" (click)="showPopup()">
            <mat-icon>edit</mat-icon> Update Profile
          </a>
          <button (click)="logOut()" class="btn1 btn1-primary logout-btn">
            <mat-icon>logout</mat-icon> Log Out
          </button>
        </div>
      </div>
    </div>
  </div>
</header> -->

<header class="navbar">

  <!-- LEFT -->
  <div class="nav-left">
    <img src="assets/logo.svg" alt="Logo" class="logo-pic"
      (click)="navigationToHome()" />
  </div>

  <!-- RIGHT -->
  <div class="nav-right">

    <!-- Nav Links Right (Desktop) -->
    <nav class="nav-links" >
      <a [class.active]="window.location.pathname.includes('home')" routerLink="/home">Home</a>
      <a  [class.active]="window.location.pathname.includes('my-courts')" *ngIf="coreService.isTwoColumn()" (click)="goToMyClubsLink()"> My Courts</a>
      <a  [class.active]="window.location.pathname.includes('all-matches')" *ngIf="coreService.isTwoColumn()" (click)="goToMyMatchResultsLink()"> Upcoming Matches</a>
      <a [class.active]="window.location.pathname.includes('help-page')" routerLink="/help-page">About</a>
      <a [class.active]="window.location.pathname.includes('contact-us')" routerLink="/contact-us">Contact Us</a>
    </nav>

    <!-- Bell -->
    <i class="icon bell"></i>

    <!-- Desktop Profile -->
    <div class="profile navright"
         
         (click)="toggleUserBtn()">
         
      <span class="avatar-circle">
        {{ ((userDetails.firstName ? userDetails.firstName[0] : '') + (userDetails.lastName ? userDetails.lastName[0] : '')) | uppercase }}
      </span>

      <mat-icon style="margin-left: 4px; color: #111827;">arrow_drop_down</mat-icon>

      <div class="userdetails glass-dropdown" *ngIf="isShowUser">
        <div class="dropdown-header">
          <span class="avatar-large" style="width: 56px; height: 56px; border-radius: 50%; background: #2A3B58; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 28px; font-weight: 600; text-transform: uppercase;">
            {{ (userDetails.firstName ? userDetails.firstName[0] : '') + (userDetails.lastName ? userDetails.lastName[0] : '') }}
          </span>
          <div class="user-info">
            <div class="username">{{ userDetails.userName }}</div>
            <div class="useremail">{{ userDetails.email }}</div>
          </div>
        </div>
        <div class="dropdown-actions">
          <a class="link update-link" (click)="showPopup()">
            <mat-icon>edit</mat-icon> Update Profile
          </a>
          <button (click)="logOut()" class="btn1 btn1-primary logout-btn">
            <mat-icon>logout</mat-icon> Log Out
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Hamburger -->
    <!-- Mobile Hamburger -->
<div class="hamburger"
     *ngIf="coreService.isBelow991()"
     (click)="toggleMobileMenu()">
  <span></span>
  <span></span>
  <span></span>
</div>

  </div>
</header>


<!-- 🔥 MOBILE MENU -->
<!-- 🔥 MOBILE MENU -->
<div class="mobile-menu" [class.active]="coreService.isMobileMenuActive">


  <div class="mobile-menu-header">
    <span style="display: flex; align-items: center; gap: 16px;">
      <span class="avatar-circle large">
        {{ ((userDetails.firstName ? userDetails.firstName[0] : '') + (userDetails.lastName ? userDetails.lastName[0] : '')) | uppercase }}
      </span>
      <span style="font-weight: 600; color: var(--text-main); font-size: 18px;">
        {{ userDetails.userName || 'User' }}
      </span>
    </span>
    <mat-icon (click)="toggleMobileMenu()">close</mat-icon>
  </div>

  <a routerLink="/home" (click)="toggleMobileMenu()">Home</a>
  <a  (click)="toggleMobileMenu(); goToMyClubs()">My Club</a>
  <a routerLink="/my-courts" (click)="toggleMobileMenu()">My Court</a>
  <a routerLink="/all-matches" (click)="toggleMobileMenu()">Upcoming Matches</a>
  <a routerLink="/my-match-results" (click)="toggleMobileMenu()">My Match Results</a>
  <a routerLink="/help-page" (click)="toggleMobileMenu()">About</a>
  <a routerLink="/contact-us" (click)="toggleMobileMenu()">Contact Us</a>
  <a (click)="toggleMobileMenu(); showPopup()">Update Profile</a>

  <button class="mobile-logout" (click)="logOut()">Logout</button>

</div>

<!-- Overlay -->
<div class="mobile-overlay"
     *ngIf="coreService.isMobileMenuActive"
     (click)="toggleMobileMenu()">
</div>